<template>
    <!-- 多选框组二次封装
        @author: liuguisheng
        @date: 2019-9-13
    -->
  <preview-form-item v-if="isDisplay && showRule!=='render'"
                     :labelText="labelName"
                     :labelWidth="labelWidth"
                     :labelPosition="labelPosition"
                     :textAlign="labelTextPosition"
                     :formType="formType"
                     :variableName="model"
                     :rules="validatorRule"
                     :paddingLeft="paddingLeft">
    <div class="form-item_input">
      <el-checkbox-group v-model="checkBoxModel"
                         :disabled="isDisabled">
        <el-checkbox v-for="(item,index) in options"
                     :style="{display: displayType}"
                     :key="index"
                     :label="item.label">
                     {{item.value}}
        </el-checkbox>
      </el-checkbox-group>
    </div>
  </preview-form-item>
</template>
<script>
/** 混入方法 ::: 
 *  @mixin mixPreviewItemTemplateChild 预览表单项子级混入
 */
import { mixPreviewItemTemplateChild } from "@/mixins/preview_item/mix_preview_item_template_child.js";


export default {
  mixins: [ mixPreviewItemTemplateChild ],
  computed: {
    /** @name 多选框选择的值
     *  @return {Array} 选择项选择的值
     *  @author 王汝鹏
     *  @version 2019-12-28
     */
    checkBoxModel: {
      get() { return this.currentModel || []; },
      set(newValue) {
        this.currentModel = this.optionValues.filter(value => newValue.includes(value)); }
    },
    /** @name 选项值数组
     *  @return {Array<String>} 选择项值数组
     *  @author 王汝鹏
     *  @version 2019-12-28
     */
    optionValues() {
      return this.options.map(option => option.label);
    }
  },
}

</script>


// WEBPACK FOOTER //
// src/components/preview_item/PreviewItemCheckbox.vue